import React, { useState } from 'react';
import ContainerCard from '../../../../common/components/ContainerCard';
import styles2 from '../../AccountPage.module.css';
import styles from './MagazineDeliverySection.module.css';

type MagazineDeliveryProps = {
  hrMagazineSubscriptionType: number;
  handleSave: (hrMagazineSubscriptionType: number) => void;
};

const MagazineDeliverySection = (props: MagazineDeliveryProps) => {
  const [isStateChanged, setIsStateChanged] = useState(false);

  const [hrMagazineSubscriptionType, setHrMagazineSubscriptionType] = useState(
    props.hrMagazineSubscriptionType
  );

  const handleChange = event => {
    setHrMagazineSubscriptionType(Number(event.target.value));
    setIsStateChanged(true);
  };
  const handleSave = () => {
    props.handleSave(hrMagazineSubscriptionType);
  };

  const handleCancel = () => {
    setHrMagazineSubscriptionType(props.hrMagazineSubscriptionType);
    setIsStateChanged(false);
  };

  return (
    <ContainerCard className={styles2.cardDimensions + ' ' + styles2.cardStrech}>
      <div className={styles.title}>HR Magazine Delivery</div>
      <div className={styles.credentialsCardContainer}>
        <p>How would you like your magazine delivered?</p>
        <div className={styles.options}>
          <label>
            <input
              type='radio'
              name='editionType'
              value='2'
              checked={hrMagazineSubscriptionType === 2}
              onChange={handleChange}
            />
            <span>Digital Only</span>
          </label>
          <label>
            <input
              type='radio'
              name='editionType'
              value='1'
              checked={hrMagazineSubscriptionType === 1}
              onChange={handleChange}
            />
            <span>Print & Digital</span>
          </label>
        </div>
      </div>
      {isStateChanged ? (
        <div className={styles.buttonContainer}>
          <button type='submit' className={styles.buttonSave} onClick={handleSave}>
            SAVE
          </button>
          <button className={styles.buttonCancel} onClick={handleCancel}>
            CANCEL
          </button>
        </div>
      ) : null}
    </ContainerCard>
  );
};

export default MagazineDeliverySection;
